import type { ReactElement } from 'react'
import { useState } from 'react'
import { Modal, Header, Spacer, Text } from '@truepill/react-capsule'
import styled from 'styled-components'

export enum MissingLicenseContext {
  NY_DISPENSING,
  NV_SHIP_TO,
}

const CONTENT: Record<MissingLicenseContext, { title: string; body: string }> = {
  [MissingLicenseContext.NY_DISPENSING]: {
    title: 'New York Pharmacy Only',
    body: 'This fill can only be handled by pharmacists assigned to a New York pharmacy who hold an active New York license.',
  },
  [MissingLicenseContext.NV_SHIP_TO]: {
    title: 'Nevada License Only',
    body: 'This fill can only be handled by Nevada licensed pharmacists or by pharmacists who work on a location where the PIC is licensed in Nevada.',
  },
}

interface ModalProps {
  shouldOpen: boolean
  context: MissingLicenseContext
}

const MissingLicenseModal = ({ shouldOpen, context }: ModalProps): ReactElement => {
  const [isOpen, setIsOpen] = useState(shouldOpen)
  const { title, body } = CONTENT[context]

  return (
    <Modal isOpen={isOpen} onDismiss={() => setIsOpen(false)} aria-labelledby="title" overlayCss={{ 'z-index': 10 }}>
      <>
        <StyledHeader variant="xl" id="title">
          {title}
        </StyledHeader>
        <Spacer />
        <StyledText>{body}</StyledText>
      </>
    </Modal>
  )
}

const StyledHeader = styled(Header)`
  font-weight: bold;
  font-size: 36px;
`

const StyledText = styled(Text)`
  font-size: 16px;
`

export default MissingLicenseModal
